export default "__VITE_ASSET__DolB$VIj__"